import { EXAM_EVENT_DATA_TEST_ID } from '@e2e/constants/exam-center';
import { ReadonlyRadioWithIconSelection } from '@exam-center/components';
import {
  getLabelAndIconByExamType,
  getLabelAndIconByRegistrationType,
} from '@exam-center/exam-event-management';
import { ExamType, RegistrationType } from '@exam-center/graphql';
import {
  Flex,
  Text,
  FormTextField,
  Grid,
  DesktopWindowsOutlinedIcon,
  DescriptionOutlinedIcon,
  BusinessOutlinedIcon,
  PublicIcon,
  ReadonlyField,
  FormRadioWithIconSelection,
} from '@shared/components';

interface BasicInformationFormFieldProps {
  isNameEditable?: boolean;
  examEventName?: string;
  isExamTypeEditable?: boolean;
  examType?: ExamType;
  isRegistrationTypeEditable?: boolean;
  registrationType?: RegistrationType;
  isShowExamType?: boolean;
}

function renderExamTypeField(
  isExamTypeEditable?: boolean,
  examTypeOptions?: {
    icon: JSX.Element;
    label: string;
    checked: boolean;
  }[],
) {
  if (isExamTypeEditable) {
    return (
      <FormRadioWithIconSelection
        name='examType'
        label='Exam Type'
        required
        row
        options={[
          {
            label: 'Computer',
            value: ExamType.Computer,
            icon: <DesktopWindowsOutlinedIcon />,
            'data-testid': EXAM_EVENT_DATA_TEST_ID.COMPUTER_TYPE,
          },
          {
            label: 'Paper',
            value: ExamType.Paper,
            icon: <DescriptionOutlinedIcon />,
            'data-testid': EXAM_EVENT_DATA_TEST_ID.PAPER_TYPE,
          },
        ]}
        sx={{
          width: 412,
        }}
        slotProps={{
          optionWrapper: {
            sx: { width: 200 },
          },
        }}
      />
    );
  }

  return <ReadonlyRadioWithIconSelection label='Exam Type' row options={examTypeOptions ?? []} />;
}
export default function BasicInformationFormField(props: Readonly<BasicInformationFormFieldProps>) {
  const {
    isNameEditable = true,
    examEventName,
    isExamTypeEditable = true,
    examType,
    isRegistrationTypeEditable = true,
    registrationType,
    isShowExamType = true,
  } = props;

  const examTypeOptions = examType ? [getLabelAndIconByExamType(examType)] : [];
  const registrationTypeOptions = registrationType
    ? [getLabelAndIconByRegistrationType(registrationType)]
    : [];

  return (
    <Grid
      sx={{
        gridTemplateColumns: '240px 1fr',
        gap: (theme) => theme.spacing(6),
      }}
    >
      <Text variant='body1Semibold'>ข้อมูลทั่วไป</Text>
      <Flex sx={{ gap: (theme) => theme.spacing(4), flexGrow: 1, flexDirection: 'column' }}>
        {isNameEditable ? (
          <FormTextField
            name='examEventName'
            label='ชื่อรอบสอบ'
            placeholder='กรุณากรอกชื่อรอบสอบ'
            required
            slotProps={{
              htmlInput: { 'data-testid': EXAM_EVENT_DATA_TEST_ID.EXAM_EVENT_NAME_INPUT },
            }}
          />
        ) : (
          <ReadonlyField label='ชื่อรอบสอบ' content={examEventName ?? ''} />
        )}
        {isShowExamType ? renderExamTypeField(isExamTypeEditable, examTypeOptions) : null}
        {isRegistrationTypeEditable ? (
          <FormRadioWithIconSelection
            name='registrationType'
            label='Registration Type'
            required
            row
            options={[
              {
                label: 'Public',
                value: RegistrationType.Public,
                icon: <PublicIcon />,
                'data-testid': EXAM_EVENT_DATA_TEST_ID.PUBLIC_TYPE,
              },
              {
                label: 'In-house',
                value: RegistrationType.InHouse,
                icon: <BusinessOutlinedIcon />,
                'data-testid': EXAM_EVENT_DATA_TEST_ID.IN_HOUSE_TYPE,
              },
            ]}
            sx={{
              width: 412,
            }}
            slotProps={{
              optionWrapper: {
                sx: { width: 200 },
              },
            }}
          />
        ) : (
          <ReadonlyRadioWithIconSelection
            label='Registration Type'
            row
            options={registrationTypeOptions}
          />
        )}
      </Flex>
    </Grid>
  );
}
